import {practiceStateActions} from '../../const/actionType';

const initialState = {
  practices: {},
  selectedPractice: null,
};

export default function practiceState(state = initialState, action) {
  switch (action.type) {
    case practiceStateActions.SET_PRACTICES:
      return {...state, practices: {...state.practices, [action.departmentId]: action.practices}};
    case practiceStateActions.SET_SELECTED_PRACTICE:
      return {...state, selectedPractice: action.selected};
    case practiceStateActions.RESET_PRACTICE:
      return initialState;
    default:
      return state;
  }
}
